import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

import ContractColumnDateFilter from "../ContractColumnDateFilter.js";
import SelectContractSituations from "../SelectContractSituations.js";
import AnimatedCardContent from "../../../AnimatedCardContent.js";
import ContractDurations from "../../../select/ContractDurations.js";
import ContractTypes from "../../../select/ContractTypes.js";
import SelectMultipleAgents from "../../../select/SelectMultipleAgents.js";
import SelectMultipleUsersByAgent from "../../../select/SelectMultipleUsersByAgent.js";
import HierarchySelect from "../../../select/HierarchySelect.js";
import { HierarchyViewTypeEnum } from "../../../../../util/index.js";
import { CONTRACT_BY_AGENT_FILTER_KEYS } from "./filterKeys.js";

const ContractsByAgentFilter = ({ currentUser, filters, updateFilter, agents, loadingAgents, selectedAgents, setSelectedAgents, users, loadingUsers, errorAgents, errorUsers }) => {
  return (
    <AnimatedCardContent>
      <Typography
        variant="h6"
        gutterBottom
      >
        <FormattedMessage id="app.filters" />
      </Typography>

      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          // sm={6}
          // md={6}
        >
          <SelectMultipleAgents
            agents={agents}
            error={errorAgents}
            loading={loadingAgents}
            selectedAgents={filters[CONTRACT_BY_AGENT_FILTER_KEYS.AGENTS]}
            setSelectedAgents={(values) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.AGENTS, values)}
          />
        </Grid>
        {/* <Grid
          item
          xs={12}
          sm={6}
          md={6}
        >
          <SelectMultipleUsersByAgent
            agents={filters[CONTRACT_BY_AGENT_FILTER_KEYS.AGENTS]}
            users={users}
            error={errorUsers}
            loading={loadingUsers}
            selectedUsers={filters[CONTRACT_BY_AGENT_FILTER_KEYS.USERS]}
            setSelectedUsers={(values) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.USERS, values)}
          />
        </Grid> */}
        <Grid
          item
          xs={12}
          md={6}
        >
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
            >
              <HierarchySelect
                value={filters[CONTRACT_BY_AGENT_FILTER_KEYS.HIERARCHY_VIEW_TYPE]}
                onChange={(value) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.HIERARCHY_VIEW_TYPE, value)}
                defaultSelected={HierarchyViewTypeEnum.DIRECTLY}
                directlyLabel="app.hierarchy.agents.directlyBelow"
                allLabel="app.hierarchy.agents.allBelow"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
            >
              <SelectContractSituations
                contractSituaions={filters[CONTRACT_BY_AGENT_FILTER_KEYS.CONTRACT_SITUATIONS]}
                setContractSituations={(values) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.CONTRACT_SITUATIONS, values)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
            >
              <ContractTypes
                value={filters[CONTRACT_BY_AGENT_FILTER_KEYS.CONTRACT_MODALITIES]}
                onChange={(values) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.CONTRACT_MODALITIES, values)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={6}
            >
              <ContractDurations
                value={filters[CONTRACT_BY_AGENT_FILTER_KEYS.CONTRACT_DURATIONS]}
                onChange={(values) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.CONTRACT_DURATIONS, values)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ContractColumnDateFilter
            column={filters[CONTRACT_BY_AGENT_FILTER_KEYS.DATE_COLUMN]}
            startDate={filters[CONTRACT_BY_AGENT_FILTER_KEYS.START_DATE]}
            finalDate={filters[CONTRACT_BY_AGENT_FILTER_KEYS.END_DATE]}
            onChangeColumn={(value) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.DATE_COLUMN, value)}
            onStartDateChange={(value) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.START_DATE, value)}
            onFinalDateChange={(value) => updateFilter(CONTRACT_BY_AGENT_FILTER_KEYS.END_DATE, value)}
          />
        </Grid>
      </Grid>
    </AnimatedCardContent>
  );
};

export default ContractsByAgentFilter;
